import { checkGCSpawn } from "./handlers/gc/checkGCSpawn";
import { updateBuffsTimer } from "./handlers/buffs/updateBuffsTimer";
import { updateGCTimer } from "./handlers/gc/updateGCTimer";
import { updateTotalBuffMultiplier } from "./handlers/buffs/updateTotalBuffMultiplier";
import { applySettings } from "./settings/applySettings";
import { createBuffsToggler } from "./handlers/buffs/createBuffsToggler";
import { replaceNativeHandlers } from "./handlers/replaceNativeHandlers";
import { setVisible, getQT } from "./utils/dom";
import { settings } from "./settings";
import { createTimer } from "./handlers/timers/createTimer";
import { initTimersContainer } from "./handlers/timers/initTimersContainer";
const QTDrawHook = () => {
    const updateFrequency = Math.max(1, settings.updateFrequency);
    if (Game.drawT % Math.ceil(updateFrequency / 2) !== 0)
        return;
    updateGCTimer();
    if (Game.drawT % updateFrequency !== 0)
        return;
    checkGCSpawn();
    updateTotalBuffMultiplier();
    updateBuffsTimer();
};
const init = () => {
    initTimersContainer();
    replaceNativeHandlers();
    createBuffsToggler();
    createTimer("GCTimer");
    createTimer("totalMult");
    setVisible(getQT("totalMult"), settings.showTotalBuffMultiplier);
    updateTotalBuffMultiplier();
    Game.registerHook("draw", QTDrawHook);
};
const save = () => JSON.stringify(settings);
const load = (dataStr) => {
    const data = JSON.parse(dataStr);
    Object.keys(data).forEach((key) => {
        if (key in settings && data[key] !== undefined) {
            settings[key] = data[key];
        }
    });
    applySettings();
};
const QTMod = {
    init,
    save,
    load,
};
if (typeof Steam !== "undefined") {
    setTimeout(() => {
        Game.registerMod(process.env.APP_NAME, QTMod);
    }, 2000);
}
else {
    Game.registerMod(process.env.APP_NAME, QTMod);
}
